import { styled } from '@mui/material';

export const EligibleTitle = styled('div')({
  fontSize: 12,
  fontWeight: 'bold',
  textTransform: 'uppercase',
  marginBottom: 8,
});
